import { icons } from '../assets'
import Transaction  from '../components/Admin/pages/transaction'

export const agentRoutes = [
    { path: '', icon: icons.transaction, title: 'Transaction', component: Transaction },
    
]